import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'slicer',
})
export class SlicerPipe implements PipeTransform {
    constructor() { }

    /**
     * JDU le 08/01/2025
     * Ce pipe a pour but de couper un tableau selon une valeur limite donnée
    */
    transform(value: Array<any>, limit: number): any {
        let result = value;
        if (value && value.length >= limit) {
            result = value.slice(0, limit)
        }
        return result;
    }
}
